var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.716 16.9441H2.30713C2.13737 16.9437 1.97469 16.876 1.85464 16.756C1.7346 16.6359 1.66696 16.4733 1.6665 16.3035V5.83301H17.6387C17.8229 5.83301 17.9995 5.90617 18.1298 6.03641C18.26 6.16664 18.3332 6.34327 18.3332 6.52745V16.3269C18.3332 16.4906 18.2681 16.6476 18.1524 16.7633C18.0367 16.8791 17.8797 16.9441 17.716 16.9441Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.83344V3.75011C1.6665 3.56593 1.73967 3.3893 1.8699 3.25906C2.00014 3.12883 2.17677 3.05566 2.36095 3.05566H6.93473C7.11867 3.05575 7.29505 3.1288 7.42518 3.25879L9.99984 5.83344",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFolder;